<div [formGroup]="parentForm" class="ms-large-b">
  <ng-container [formArrayName]="controlName">
    @for (iteratedInput of formArray.controls; track iteratedInput; let i = $index) {
      <fin-form-input-checkbox
        [parentForm]="parentForm.get(controlName)"
        [checkboxValue]="checkboxList[i].id"
        [translationPrefix]="checkboxList[i].label"
        [controlName]="i + ''"
      />
    }
  </ng-container>
</div>
